import { UsersIcon } from "lucide-react";

import { UserSettingsFragment } from "@/__generated__/graphql";
import { ObjectType } from "@/objects/@types";

const object: ObjectType<UserSettingsFragment> = {
  humanName: "user-settings",
  typename: "UserSettingsObject",
  ReactIcon: UsersIcon,
  getTitle: () => {
    return "User Settings";
  },
  getEntityId: () => {
    return null;
  },
  fieldDefinitions: [],
};

export { object as UserSettingsObject };
